module.exports = __webpack_public_path__ + "img/vade.5ce0c5f8.webp";